import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { full } from "./shared/routes/full.routes";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { AdminGuard } from "./shared/guard/admin.guard";
import { LoginComponent } from "./auth/login/login.component";
import { RegisterFormComponent } from "./auth/register-form/register-form.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ChangePasswordComponent } from "./auth/change-password/change-password.component";
import { ViewSharedFeaturesComponent } from "./auth/view-shared-features/view-shared-features.component";
import { ViewPublishedFeaturesComponent } from "./auth/view-published-features/view-published-features.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { QuestionnarieComponent } from "./components/institute/questionnarie/questionnarie.component";
import { QuestionnarieViewTableComponent } from "./components/institute/questionnarie-view-table/questionnarie-view-table.component";
import { DemoVideoComponent } from "./auth/demo-video/demo-video.component";


const routes: Routes = [
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full",
  },
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "auth/register",
    component: RegisterFormComponent,
  },
  {
    path: "auth/forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "auth/sharedArticle/:id",
    component: ViewSharedFeaturesComponent,
  },
  {
    path: "auth/publishedArticle",
    component: ViewPublishedFeaturesComponent,
  },
  {
    path: "auth/change-password",
    component: ChangePasswordComponent,
  },
  {
    path: "auth/reset-password/:token",
    component: ResetPasswordComponent
  },
  {
    path: "auth/demoVideo",
    component: DemoVideoComponent,
  },
  {
    path: "institute/:id/questionnarie/:quesId",
    component: QuestionnarieComponent,
    canActivate: [AdminGuard]
  },
  {
    path: ":studentId/questionnarie-view-Table/:id/:index/:isEmail/:institutionId",
    component: QuestionnarieViewTableComponent,
    canActivate: [AdminGuard]
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [AdminGuard],
    children: content,
  },
  {
    path: "",
    component: FullComponent,
    canActivate: [AdminGuard],
    children: full,
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
